import Marquee from 'react-fast-marquee';

const MarqueeRibbon = () => {
  const text = "PHOTOGRAPHY & VIDEOGRAPHY • MONTREAL & TORONTO • CAPTURE THE MOMENT • ";

  return (
    <div className="bg-charcoal py-4 overflow-hidden" data-testid="marquee-section">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {[...Array(4)].map((_, i) => (
          <span
            key={i}
            className="font-sans text-sm tracking-superwide text-cream mx-8"
          >
            {text}
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeRibbon;
